var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMap2Line(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33203 3.33337L5.9987 1.33337L9.9987 3.33337L14.2007 1.53251C14.37 1.45999 14.5659 1.53837 14.6384 1.70758C14.6562 1.74907 14.6654 1.79375 14.6654 1.83889V12.6667L9.9987 14.6667L5.9987 12.6667L1.79667 14.4676C1.62746 14.5401 1.4315 14.4617 1.35898 14.2925C1.3412 14.251 1.33203 14.2063 1.33203 14.1612V3.33337ZM10.6654 12.9304L13.332 11.7875V3.35543L10.6654 4.49828V12.9304ZM9.33203 12.8426V4.49075L6.66536 3.15742V11.5093L9.33203 12.8426ZM5.33203 11.5018V3.06971L2.66536 4.21257V12.6446L5.33203 11.5018Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap2Line);
export default __webpack_public_path__ + "static/media/map-2-line.a49c5815365633864880df0ba20a5f72.svg";
export { ForwardRef as ReactComponent };